import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { reduxForm, Field, formValueSelector, reset } from "redux-form";
import { Masks, Permissions, Activities, Office } from "../constants/enums";
import isEqual from "lodash/isEqual";
import {
    required,
    validateEmail,
    validatePhone,
    formatPhone
} from "../utility";
import {
    CLIENT_LOADED,
    USER_UPDATE,
    MESSAGE_SENDED,
    LOGOUT
} from "../constants/actionTypes";
import {
    MaterialTextField,
    MaterialMaskedTextField,
    MaterialCheckbox
} from "./MaterialInput";
import PrimaryDivider from "./PrimaryDivider";
import SubmitButton from "./SubmitButton";
import Fade from "@material-ui/core/Fade";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const permissionsUserForm = ({
    editedUserId,
    loggedUserPermissions,
    loggedUserId,
    onEditUser,
    handleSubmit
}) => (
    <form
        className="wide-column common-form"
        onSubmit={handleSubmit(data => {
            let permissions = Object.keys(data).filter(p => !!data[p]);
            if (
                editedUserId === loggedUserId &&
                loggedUserPermissions.includes("users-edit") &&
                !permissions.includes("users-edit")
            ) {
                let c = window.confirm(
                    "Запретив доступ к редактированию пользователей, вы лишитесь возможности вернуть себе эту функцию. Подтвердите выбор"
                );
                return c
                    ? onEditUser(
                          editedUserId,
                          { permissions },
                          !isEqual(loggedUserPermissions, permissions)
                      )
                    : void 0;
            }
            return onEditUser(
                editedUserId,
                { permissions },
                editedUserId === loggedUserId &&
                    !isEqual(loggedUserPermissions, permissions)
            );
        })}
    >
        <Typography variant="h5" align="center">
            Доступ
        </Typography>
        {Object.keys(Permissions).map((p, i) => (
            <FormControlLabel
                key={i}
                control={<Field name={p} component={MaterialCheckbox} />}
                label={Permissions[p]}
            />
        ))}
        <SubmitButton label="Сохранить изменения" />
    </form>
);

const PermissionUserForm = connect(state => {
    const { user: { permissions = [] } = {} } = state.client;

    return {
        enableReinitialize: true,
        initialValues: permissions.reduce(
            (p, c) => Object.assign(p, { [c]: true }),
            {}
        )
    };
})(reduxForm({ form: "edit-permission-form" })(permissionsUserForm));

const positionUserForm = ({ editedUserId, onEditUser, handleSubmit }) => (
    <form
        className="common-column common-form"
        onSubmit={handleSubmit(data => onEditUser(editedUserId, data, false))}
    >
        <Typography variant="h5" align="center">
            Должности
        </Typography>
        <Field
            name="position"
            label={`ЗАО "АВТО-ФИНАНС"`}
            component={MaterialTextField}
            InputLabelProps={{ shrink: true }}
            placeholder="в лице..."
        />
        <Field
            name="attorney"
            label={`ЗАО "АВТО-ФИНАНС"`}
            component={MaterialTextField}
            rows={5}
            multiline
            InputLabelProps={{ shrink: true }}
            placeholder="действует на основании..."
        />
        <Field
            name="positionPawnshop"
            component={MaterialTextField}
            InputLabelProps={{ shrink: true }}
            label={`Автоломбард`}
            placeholder="в лице..."
        />
        <Field
            name="attorneyPawnshop"
            component={MaterialTextField}
            InputLabelProps={{ shrink: true }}
            rows={5}
            multiline
            label={`Автоломбард`}
            placeholder="действует на основании..."
        />
        <Field
            name="positionLeasing"
            component={MaterialTextField}
            InputLabelProps={{ shrink: true }}
            label={`"ЛК «АВТОМОБИЛЬНОСТЬ»"`}
            placeholder="в лице..."
        />
        <Field
            name="attorneyLeasing"
            component={MaterialTextField}
            rows={5}
            multiline
            InputLabelProps={{ shrink: true }}
            label={`"ЛК «АВТОМОБИЛЬНОСТЬ»"`}
            placeholder="действует на основании..."
        />
        <SubmitButton label="Сохранить изменения" />
    </form>
);

const PositionUserForm = connect(state => {
    const { user } = state.client;
    return {
        enableReinitialize: true,
        initialValues: user
    };
})(reduxForm({ form: "edit-position-form" })(positionUserForm));

const changePasswordForm = ({
    editedUserId,
    onChangePassword,
    handleSubmit
}) => {
    return (
        <form
            className="common-column common-form"
            onSubmit={handleSubmit(data =>
                onChangePassword(editedUserId, data)
            )}
        >
            <Typography variant="h5" align="center">
                Сменить пароль
            </Typography>
            <Field
                name="newPassword"
                type="password"
                label="Новый пароль"
                component={MaterialTextField}
            />
            <Field
                name="newPasswordConfirm"
                type="password"
                label="Подтвердить новый пароль"
                component={MaterialTextField}
            />
            <SubmitButton label="Сохранить изменения" />
        </form>
    );
};

const ChangePasswordForm = reduxForm({ form: "change-password-form" })(
    changePasswordForm
);

const editUserForm = ({
    handleSubmit,
    isJuridicalPerson,
    onEditUser,
    editedUserId
}) => (
    <form
        className="common-column common-form"
        onSubmit={handleSubmit(data => onEditUser(editedUserId, data, false))}
    >
        <Typography variant="h5" align="center">
            Данные
        </Typography>
        <Field
            name="fullname"
            component={MaterialTextField}
            validate={required}
            label="ФИО"
        />
        <Field
            name="phone"
            component={MaterialMaskedTextField}
            mask={Masks.phone}
            validate={validatePhone}
            placeholder="+7 (___) ___-__-__"
            format={formatPhone}
            label="Номер телефона"
        />
        <Field
            name="sex"
            select
            validate={required}
            component={MaterialTextField}
            label="Пол"
        >
            <MenuItem value="M">Мужской</MenuItem>
            <MenuItem value="F">Женский</MenuItem>
        </Field>
        <Field
            component={MaterialTextField}
            name="email"
            validate={validateEmail}
            label="Электронный адрес"
        />
        <Field
            name="pasport.serial"
            component={MaterialMaskedTextField}
            mask={Masks.passport}
            label="Серия и номер паспорта"
        />
        <Field
            name="pasport.date"
            component={MaterialMaskedTextField}
            mask={Masks.date}
            label="Дата выдачи паспорта"
        />
        <Field
            name="type"
            select
            component={MaterialTextField}
            label="Правовой статус"
        >
            <MenuItem value="NATURAL_PERSON">Физическое лицо</MenuItem>
            <MenuItem value="JURIDICAL_PERSON">Юридическое лицо</MenuItem>
        </Field>
        <FormControlLabel
            control={
                <Field
                    name="officeNewcherkassky"
                    component={MaterialCheckbox}
                />
            }
            label="Офис НВЧ"
        />
        <FormControlLabel
            control={<Field name="officeMoscow" component={MaterialCheckbox} />}
            label="Офис МСК"
        />
        {isJuridicalPerson && (
            <Fade in={isJuridicalPerson}>
                <React.Fragment>
                    <Field
                        name="org.phone"
                        mask={Masks.phone}
                        placeholder="+7 (___) ___-__-__"
                        component={MaterialMaskedTextField}
                        label="Рабочий номер телефона"
                    />
                    <Field
                        name="org.email"
                        component={MaterialTextField}
                        label="Рабочий электронный адрес"
                    />
                    <Field
                        name="org.site"
                        component={MaterialTextField}
                        label="Рабочий веб-сайт"
                    />
                    <Field
                        name="org.activity"
                        select
                        component={MaterialTextField}
                        label="Род деятельности"
                    >
                        {Activities.map((a, i) => (
                            <MenuItem key={i} value={a}>
                                {a}
                            </MenuItem>
                        ))}
                    </Field>
                </React.Fragment>
            </Fade>
        )}
        <SubmitButton label="Сохранить изменения" />
    </form>
);

const EditUserForm = connect(state => {
    const { user } = state.client;
    return {
        isJuridicalPerson:
            formValueSelector("edit-user-form")(state, "type") ===
            "JURIDICAL_PERSON",
        enableReinitialize: true,
        initialValues: user
    };
})(reduxForm({ form: "edit-user-form" })(editUserForm));

class EditUser extends React.Component {
    state = {
        minifiedInterface:
            window.localStorage.getItem("minifiedInterface") === "true"
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        const { editedUserId, onLoad } = this.props;
        agent.User.get(editedUserId)
            .then(onLoad)
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    }
    toggleInterfaceType = () => {
        const { minifiedInterface } = this.state;
        window.localStorage.setItem("minifiedInterface", !minifiedInterface);
        this.setState({ minifiedInterface: !minifiedInterface }, () =>
            window.location.reload()
        );
    };

    render() {
        const {
            editedUserId,
            loggedUserId,
            loggedUserPermissions = [],
            onEditUser,
            onChangePassword
        } = this.props;
        const { minifiedInterface } = this.state;

        return (
            <Fade in={true}>
                <div style={{ overflow: "hidden" }}>
                    <Typography variant="h4">
                        Редактировать пользователя
                    </Typography>
                    <PrimaryDivider />
                    <Grid
                        container
                        justify="center"
                        spacing={16}
                        style={{ paddingBottom: "20px" }}
                    >
                        <Grid item>
                            <Paper className="common-paper">
                                <EditUserForm
                                    editedUserId={editedUserId}
                                    loggedUserId={loggedUserId}
                                    loggedUserPermissions={
                                        loggedUserPermissions
                                    }
                                    onEditUser={onEditUser}
                                />
                            </Paper>
                        </Grid>
                        {loggedUserPermissions.includes("users-edit") && (
                            <Grid item>
                                <Paper className="common-paper">
                                    <PermissionUserForm
                                        editedUserId={editedUserId}
                                        loggedUserId={loggedUserId}
                                        loggedUserPermissions={
                                            loggedUserPermissions
                                        }
                                        onEditUser={onEditUser}
                                    />
                                </Paper>
                            </Grid>
                        )}
                        <Grid item>
                            <Paper className="common-paper">
                                <PositionUserForm
                                    editedUserId={editedUserId}
                                    onEditUser={onEditUser}
                                />
                            </Paper>
                        </Grid>
                        {loggedUserPermissions.includes("users-edit") && (
                            <Grid item>
                                <Paper className="common-paper">
                                    <ChangePasswordForm
                                        editedUserId={editedUserId}
                                        onChangePassword={onChangePassword}
                                    />
                                </Paper>
                            </Grid>
                        )}
                        {loggedUserId === editedUserId && (
                            <Grid item>
                                <Paper className="common-paper">
                                    <div className="common-column">
                                        <Typography variant="h5" align="center">
                                            Интерфейс
                                        </Typography>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={minifiedInterface}
                                                    onChange={
                                                        this.toggleInterfaceType
                                                    }
                                                />
                                            }
                                            label="Лаконичный"
                                        />
                                    </div>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </Fade>
        );
    }
}

const mapStateToProps = (state, { match }) => ({
    loggedUserId: state.common.user.id,
    loggedUserPermissions: state.common.user.permissions,
    editedUserId: match.params.userId
});

const mapDispatchToProps = (dispatch, { match }) => ({
    onLoad: user =>
        dispatch({
            type: CLIENT_LOADED,
            payload: {
                ...user,
                id: match.params.userId
            }
        }),
    onEditUser: (id, data, logout = false) =>
        agent.User.editUser(id, data)
            .then(user => {
                if (logout) {
                    dispatch({ type: LOGOUT });
                } else {
                    dispatch({ type: USER_UPDATE, user: user });
                }
            })
            .then(() =>
                dispatch({
                    type: MESSAGE_SENDED,
                    payload: {
                        text: `Изменения успешно сохранены${
                            logout
                                ? ". Для применения новых настроек доступа необходимо войти заново"
                                : ""
                        }`,
                        type: "success"
                    }
                })
            )
            .catch(e => {
                dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                });
                dispatch(reset("edit-user-form"));
            }),
    onChangePassword: (id, data) =>
        agent.User.changePassword(id, data).then(() => {
            dispatch({
                type: MESSAGE_SENDED,
                payload: {
                    text: "Изменения успешно сохранены",
                    type: "success"
                }
            });
            dispatch(reset("change-password-form"));
        })
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);



// WEBPACK FOOTER //
// ./src/components/EditUser.js